// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixField } from './PFixField';
export class PFixSignatureField extends PFixField {
    constructor(fieldId, buffer) {
        super(fieldId, buffer);
        this.Value = new Array(0);
    }
    ReadValue(buffer) {
        const len = buffer.ReadShort();
        const data = buffer.ReadBuffer(len).ReadAllBytes();
        this.Value = data;
    }
    Write(buffer) {
        buffer.WriteShort(this.FieldId);
        if (this.Value == null) {
            return;
        }
        buffer.WriteShort(this.Value.length);
    }
}
